import React from "react";
import axios from "axios"

import Textarea from "./form/Textarea"
import Input from "./form/Input"
import Section from "./form/Section"
import Checkbox from "./form/CheckBox"
import Select from "./form/Select"
import Calendar from "./form/Calendar"
import Uploader from "./form/Uploader"
import Divider from "./form/Divider"
import Markdown from "./form/Markdown"


import {
    generateSuccessElement,
    generateErrorElement,
    generateActionElement,
    sendEvent
} from "./util";

const markdURL = "https://cdn.jsdelivr.net/npm/marked@4.2.12/marked.min.js";

export default class extends React.Component {


    constructor() {
        super();

        this.state = {
            formDescription: null,
            status: "new",
            id: Math.random()
        };

        this.formData = {
            '__url__': window.location.href,
            '__username__': window["PlatformSDK"] && window["PlatformSDK"].userFullName
        };

        this.submitForm = this.submitForm.bind(this);
        this.resetForm = this.resetForm.bind(this);
        this.checkForm = this.checkForm.bind(this);
    }


    generateContent(formDescription, config, status, location) {

        if (status == "success") {
            return <div className="container pubhub-smartsheet-form-content">
                {generateSuccessElement(formDescription, config, status, this)}
            </div>
        }

        if (status == "error") {
            return <div className="container pubhub-smartsheet-form-content">
                {generateErrorElement(formDescription, config, status, this)}
            </div>
        }


        const formElemenets = this.generateFormElement(formDescription, config, status);
        const actions = generateActionElement(formDescription, config, status, this);

        let content = <div className="container pubhub-smartsheet-form-content">
            {formElemenets}
            {actions}
        </div>

        return content;

    }

    generateFormElement(formDescription, config, status, location) {
        return formDescription.fields.map((field, index) => {
            return this.formElementSelector(field, index, config, status, location)
        });
    }

    formElementSelector(field, index, config, location) {

        const id = field.id || field.name;
        // enhance
        if (field.parameters) {
            const type = field.parameters["type"];

            if (type && type == "multiselect") {
                return <Select field={field} config={config} key={id} formData={this.formData}
                               onChange={this.checkForm} multiselect={true} id={this.state.id}/>
            }

            if (type && type == "singleselect") {
                return <Select field={field} config={config} key={id} formData={this.formData}
                               onChange={this.checkForm} multiselect={false} id={this.state.id}/>
            }

            if (type && type == "fileupload") {
                return <Uploader field={field} config={config} key={id} formData={this.formData}
                                 onChange={this.checkForm} id={this.state.id}/>
            }

            if (type && type == "markdown") {
                return <Markdown field={field} config={config} key={id} formData={this.formData}
                                 onChange={this.checkForm} id={this.state.id}/>
            }

        }


        if (field.type == "Heading") {
            return <Section field={field} config={config} key={index} id={this.state.id}/>
        }

        if (field.type == "TextArea") {
            return <Textarea field={field} config={config} key={id} formData={this.formData}
                             onChange={this.checkForm} id={this.state.id}/>
        }

        if (field.type == "TextField") {
            return <Input field={field} config={config} key={id} formData={this.formData}
                          onChange={this.checkForm} id={this.state.id}/>
        }


        if (field.type == "CheckBox") {
            return <Checkbox field={field} config={config} key={id} formData={this.formData}
                             onChange={this.checkForm} id={this.state.id}/>
        }

        if (field.type == "Select") {
            return <Select field={field} config={config} key={id} formData={this.formData}
                           onChange={this.checkForm} id={this.state.id}/>
        }

        if (field.type == "DateField") {
            return <Calendar field={field} config={config} key={id} formData={this.formData}
                             onChange={this.checkForm} id={this.state.id}/>
        }

        if (field.type == "Divider") {
            return <Divider key={index}/>
        }


        return null
    }


    checkForm() {
        const {formDescription} = this.state;
        const valid = formDescription.fields.every((item) => {
            if (item.required) {

                if (item.type == "CheckBox") {
                    if (item["parameters"] && item["parameters"]["type"] == "mandatory") {
                        return this.formData[item.name]
                    } else {
                        return true
                    }

                }

                // check if the formData contains all the required value
                return !!this.formData[item.name]
            }
            return true
        });

        if (valid) {
            this.setState({
                status: "valid"
            });

            sendEvent("onFormValid", this);


        } else {
            this.setState({
                status: "new"
            })
        }

    }

    submitForm() {

        this.setState({
            status: "loading"
        });

        delete this.formData["__profile__"]
        delete this.formData["__username__"]
        delete this.formData["id"]

        const url = `${PubHub.APIHost}/v1/smartsheets/sheets/${this.sheetid}/data`;
        axios(url, {
            method: "post",
            data: this.formData,
            withCredentials: true,
            crossDomain: true
        }).then(() => {
            this.setState({
                status: "success"
            });

            sendEvent("onFormSubmitSuccess", this);

        }).catch(() => {
            this.setState({
                status: "error"
            });

            sendEvent("onFormSubmitError", this);

        })
    }

    resetForm(e) {

        const status = this.state.status;

        this.setState({
            status: "new"
        });


        if (status == "success") {
            sendEvent("onSubmitSuccess", this);
        }

        if (status == "error") {
            sendEvent("onSubmitError", this);
        }
    }

    updateFormData(data) {
        this.formData = {...this.formData, ...data};
        this.setState({
            id: Math.random()
        })
    }


    componentDidMount() {
        if (!PubHub.instance) {
            PubHub.instance = {}
        }
        if (!PubHub.instance.extendedform) {
            PubHub.instance.extendedform = [];
        }
        PubHub.instance.extendedform.push(this);
        const sheetid = this.sheetid = this.props.config.querySelector("sheetid").innerText.trim();
        const formid = this.formid = this.props.config.querySelector("formid").innerText.trim();
        const formDescription = this.props.config.querySelector("formDescription") ? this.props.config.querySelector("formDescription").innerText.trim() : null;
        if (formDescription) {
            try {
                const formDescriptionJSON = JSON.parse(formDescription);
                this.setState({
                    formDescription: formDescriptionJSON
                });

                this.checkForm();

                sendEvent("onFormInit", this);

            } catch (e) {
                console.error("formDescription JSON error")
            }
        } else {

            const url = `${PubHub.APIHost}/v1/smartsheets/sheets/${sheetid}/forms/${formid}`
            axios.get(url).then((response) => {
                this.setState({
                    formDescription: response.data
                });

                this.checkForm();

                sendEvent("onFormInit", this);

            })
        }

        if (!window["marked"]) {
            PubHub.util.loadJSFile(markdURL).then(() => {
                this.setState({
                    id: Math.random()
                })
            })
        }
    }


    render() {
        const {config, location} = this.props;
        const {formDescription, status} = this.state;
        if (!window["PlatformSDK"]) {
            return null
        }
        // if(!PlatformSDK.isLoggedIn()){
        //     PlatformSDK.openLogin()
        //     return null;
        // }

        if (!config || !formDescription) {
            return <span className="pubhub-loading"></span>
        }

        const title = formDescription.name;
        const content = this.generateContent(formDescription, config, status, location);

        return (
            <div className={"pubhub-smartsheet-form pubhub-smartsheet-form-status-" + status}
                 ref={(el) => this.formRoot = el}>
                <div className="container">
                    <div className="pubhub-smartsheet-form-title row">
                        <div className="col">
                            <h2>
                                {title}
                            </h2>
                        </div>
                    </div>
                </div>

                {content}

            </div>
        )
    }
}
